var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#dfeef7;}.b{fill:#fd9;}.b,.c{stroke:#1f3951;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.c{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1225 -4733)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M292.252,275.076h-5.041V271.3l-11.341,7.561,11.341,7.561v-3.78h5.041a6.319,6.319,0,0,1,6.3,6.3c0,3.465-2.94,5.456-6.3,6.3a18.559,18.559,0,0,0-2.33.589,3.9,3.9,0,0,0-1.731,1.244,3.261,3.261,0,0,0-.439,2.9,4.143,4.143,0,0,0,2.785,2.587,10.6,10.6,0,0,0,7.087-.825,14.536,14.536,0,0,0,5.415-4.118l.083-.1a13.843,13.843,0,0,0-10.87-22.438Z",
    transform: "translate(969.887 4478.05)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1226 4734)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M260.642,260v10.081H243V260",
    transform: "translate(-226.821 -260)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 6.98,
    transform: "translate(6.98 44.264)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M280,280V260H230v50h36.25A13.79,13.79,0,0,0,280,296.25h0a13.79,13.79,0,0,0-13.75-13.75h-5v-3.75L250,286.25l11.25,7.5V290h5a6.268,6.268,0,0,1,6.25,6.25h0a6.268,6.268,0,0,1-6.25,6.25H260",
    transform: "translate(-230 -260)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.362b275123a05e55f697e8296caf9752.svg";
export { ForwardRef as ReactComponent };